/**
 * Constants for the AI-powered response formatter feature.
 * Centralizes configuration values used across hooks, components, and services.
 */

export const FORMAT_RESPONSE = {
  /**
   * Maximum character length for expert response text.
   * Prevents excessively long requests that may timeout or fail.
   */
  MAX_TEXT_LENGTH: 50000,

  /**
   * Delay in milliseconds before resetting button states (e.g., "Copied!" -> "Copy").
   */
  BUTTON_RESET_DELAY_MS: 2000,

  /**
   * Timeout duration for the format response API call.
   * Set slightly lower than server timeout (30s) to avoid race conditions
   * where both client and server timeout simultaneously.
   */
  API_TIMEOUT_MS: 25000,
} as const;
